import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { isNull } from "lodash";
import { connect } from "react-redux";
import { createStructuredSelector } from "reselect";

import { useStateSelector } from "utils/field";
import { validateField } from "utils/fieldValidation";

import { change } from "store/root/actions";
import { setFormErrors, removeFormErrors } from "store/form/actions";

import { selectFormErrors } from "store/form/selectors";

const Field = ({
    name,
    rules,
    component: FieldComponent,
    otherStyles,
    hasLabel,
    floor,
    fieldKey,
    customValidateFunc = null,
    validate: additionalRules = [],
    onChange = null,
    validationTrigger = null,
    label,
    formErrors,
    setFormErrors,
    removeFormErrors,
    addError = true,
    disabled = false,
    input = {},
    hideField = false,
    ...props
}) => {
    const dispatch = useDispatch();

    const [errors, setErrors] = useState([]);
    const [invalid, setInvalid] = useState();

    const value = useStateSelector(name);
    const modelUnits = useStateSelector("model.modelData.uiSettings.primaryUnits");

    const runValidation = (val) => {
        const { errors: validationErrors, invalid: validationInvalid } = validateField(fieldKey, val, additionalRules);

        const customValidationError = customValidateFunc ? customValidateFunc(val) : undefined;

        const errorsToSet = customValidationError !== undefined ? [customValidationError] : validationErrors;

        if (
            !formErrors.find(({ name: fieldName }) => fieldName === name) &&
            errorsToSet.length > 0 &&
            addError &&
            !disabled &&
            !hideField &&
            label !== "Nominal R-Value"
        ) {
            setFormErrors({
                name,
                errors: errorsToSet,
                label,
            });
        }

        if (formErrors.find(({ name: fieldName }) => fieldName === name) && errorsToSet.length === 0) {
            removeFormErrors(name);
        }

        return {
            errorsToSet,
            invalidToSet: validationInvalid || !!customValidationError,
        };
    };

    useEffect(() => {
        if (disabled || hideField) {
            removeFormErrors(name);
        }
    }, [disabled, hideField, name]);

    useEffect(() => {
        if (!isNull(validationTrigger)) {
            const { errors: validationErrors, invalid: validationInvalid } = validateField(
                fieldKey,
                value,
                additionalRules
            );

            const customValidationError = customValidateFunc ? customValidateFunc(value) : undefined;

            const errorsToSet = customValidationError !== undefined ? [customValidationError] : validationErrors;

            if (
                !formErrors.find(({ name: fieldName }) => fieldName === name) &&
                errorsToSet.length > 0 &&
                addError &&
                !disabled &&
                !hideField &&
                label !== "Nominal R-Value"
            ) {
                setFormErrors({
                    name,
                    errors: errorsToSet,
                    label,
                });
            }

            // Inner state
            setErrors(errorsToSet);
            setInvalid(validationInvalid);
        }
    }, [validationTrigger]);

    const handleChange = (val) => {
        const { errorsToSet, invalidToSet } = runValidation(val);

        // Inner state
        setErrors(errorsToSet);
        setInvalid(invalidToSet);
        // Redux state

        dispatch(change(name, val));

        if (typeof onChange === "function") onChange(val);
    };

    return (
        <FieldComponent
            input={{
                value: value != null ? value : "",
                onChange: handleChange,
                name: name ? name : null,
                ...input,
            }}
            invalid={invalid}
            meta={{
                error: errors[0],
                invalid: errors.length > 0,
            }}
            error={errors[0]} // For now, just pass the first error
            name={name}
            otherStyles={otherStyles}
            hasLabel={hasLabel}
            floor={floor}
            label={label}
            disabled={disabled}
            hideField={hideField}
            {...props}
        />
    );
};

const mapStateToProps = createStructuredSelector({
    formErrors: selectFormErrors,
});

const mapDispatchToProps = (dispatch) => ({
    setFormErrors: (error) => dispatch(setFormErrors(error)),
    removeFormErrors: (errorName) => dispatch(removeFormErrors(errorName)),
});

export default connect(mapStateToProps, mapDispatchToProps)(Field);
